@if (approvalPending) {
  <div class="alert alert-warning m-2" role="alert">
    Your NuReferral Program Protocols have been updated and require approval.
    <a routerLink="/ce-portal/referral-program-protocol">Please review and approve your current protocol here.</a>
  </div>
}
